import React, { useCallback, useEffect, useState } from "react";
import { common } from "../../../strings";
import { useAuth } from "../../AuthContext";
import { LandingPage } from "./LandingPage";

const loadingstr = common();

interface RequireAuthProps {
  children: React.ReactNode;
}

export const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { checkIsAuthenticated, isLoading } = useAuth();
  const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [checking, setChecking] = useState<boolean>(true);

  const checkAuth = useCallback(async () => {
    try {
      const result = await checkIsAuthenticated();
      setAuthenticated(result);
    } catch (error) {
      console.error("Error checking authentication:", error);
      setAuthenticated(false);
    } finally {
      setChecking(false);
    }
  }, [checkIsAuthenticated]);

  useEffect(() => {
    if (!isLoading) {
      checkAuth();
    }
  }, [checkAuth, checkIsAuthenticated, isLoading]);

  if (isLoading || checking) {
    return <div>{loadingstr.loading}</div>;
  }

  return authenticated ? <div style={{ height: "100%" }}>{children}</div> : <LandingPage />;
};
